export default __webpack_public_path__ + "static/media/header_logo.e36acf9f.svg";